import { Box, Stack, Button, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonDeleteButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

export default function MedicineMapping() {
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [TherapyMapList, setTherapyMapList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Therapy Configuration", "Therapy Medicine Mapping", "SubTab")?.editAccess
    useEffect(() => {
        getTherapyMappingData()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getTherapyMappingData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.MEDICINE_MAPPING_CONFIGURATION)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const transformedData = (response.data.data || []).map((item) => ({
                            id: item.id ?? item.treatment_ms_id,
                            treatment_code: item.treatment_code,
                            treatment_name: item.treatment_name,
                            treatment_ms_id: item.treatment_ms_id,
                            count: item.drugs?.length || 0,
                            is_active: item.is_active !== undefined ? item.is_active : true,
                            drugs: item.drugs || []
                        }))
                        setTherapyMapList(transformedData)
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        const handleDeleteRow = (row) => {
            setDeleteRow(row);
            setisDelete(true);
        };
        const gridToolBar = () => (
            <Box>
                <CommonGridToolBarWithFilterText />
            </Box>
        );

        TherapyMapList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'treatment_code', headerName: 'Treatment Code', flex: 0.2,
                renderCell: (params) => (params.row.treatment_code ? params.row.treatment_code?.length > 10 ?
                    <Tooltip placement="top" title={params.row.treatment_code}><Typography fontSize={'0.9vw'}>{params.row.treatment_code?.slice(0, 10) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.treatment_code}</Typography> : '-')
            },
            {
                field: 'treatment_name', headerName: 'Therapy Name', flex: 0.5,
                renderCell: (params) => (params.row.treatment_name ? params.row.treatment_name?.length > 50 ?
                    <Tooltip placement="top" title={params.row.treatment_name}><Typography fontSize={'0.9vw'}>{params.row.treatment_name?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.treatment_name}</Typography> : '-')
            },
            {
                field: 'count', headerName: 'No of Medicine', flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.count || '0'}</Box>)

            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? "Active" : "Inactive" || "-"}</Box>)

            },
            {
                field: 'action', headerName: 'Action', flex: 0.1, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <CommonEditButton size="1.5vw" onClick={() => { history.push("/Settings/TherapyConfig/AddTherapyMedicineMaster", { id: params.row?.id, treatment_ms_id: params.row?.treatment_ms_id, TherapyDetails: params.row }) }} />
                        <CommonDeleteButton size="1.5vw" disable={!commonDisable} onClick={() => handleDeleteRow(params.row)} />
                    </Stack>)
            },
        ]
        return (
            <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
                <DataGrid
                    // checkboxSelection = {commonDisable ? true : false}
                    // selectionModel={CheckBoxList}
                    // onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={TherapyMapList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setDeleteRow(null);
    };

    const deleteTherapyMapping = () => {
        if (!deleteRow) return;
        try {
            setisloader(true);
            const treatmentMsId = deleteRow.treatment_ms_id ?? deleteRow.id;
            const id = deleteRow.id;
            RestAPIService.delete(`${Serviceurls.MEDICINE_MAPPING_CONFIGURATION}?treatment_ms_id=${treatmentMsId}&id=${id}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message);
                        getTherapyMappingData();
                        closeFilter();
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                })
                .finally(() => setisloader(false));
        } catch (e) {
            setisloader(false);
            errorMessage(e.message);
        }
    };

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '12vw', mt: "0.5vw", mb: "0.5vw" }} disabled={!commonDisable} onClick={() => { history.push("/Settings/TherapyConfig/AddTherapyMedicineMaster") }}>ADD MAPPING</Button>
            </Box>
            <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ? (
                <DeletePopup
                    DeletTitle="Are you sure you want to delete this therapy medicine mapping?"
                    DeleteNotify="This will remove the mapping and can affect configuration."
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteTherapyMapping}
                />
            ) : null}
        </Box>
    )
}